import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSeacloud } from 'seacloud-sdk';
import App from './App';
import './index.css';

// Initialize SeaCloud SDK with 2 minute timeout
initSeacloud({
  timeout: 120000
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
